module.exports = __webpack_public_path__ + "static/yl-23b3611327cbd6c7244f74e4cd4a37f8.png";